<template>
	<transition name="slide-fade">
	<div class="cont">
		<img src="../../static/close.png" alt="" @click="back">
		<p>{{form.login}}</p>
		<transition name="slide">
			<p v-if="err.value" class="err" :class="{green: err.ok}">{{err.mess}}</p>
		</transition>
		<label for="pass">Пароль</label>
		<input type="password" id="pass" v-model="form.password" @focus="err.value = false">
		<label for="confirm">Подтверждение пароля</label>
		<input type="password" id="confirm" v-model="form.confirm" @focus="err.value = false">
		<label for="comment">Комментарий</label>
		<input type="text" id="comment" v-model="form.comment" @focus="err.value = false">
		<label for="role">Роль</label>
		<select name="operators" id="role" v-model="form.role" @focus="err.value = false">
			<option :value="2">Оператор</option>
			<option :value="1">Power User</option>
		</select>
		<label for="operators">Оператор</label>
		<select name="operators" id="operators" v-model="form.operator" @focus="err.value = false">
			<option :value="operator.name" v-for="operator in operatorList" :key="operator.name">{{operator.name}}</option>
		</select>
		<input type="button" value="Обновить данные" @click="send">
	</div>
	</transition>
</template>
<script>
	import { performRequest }                       from "../script/ws/wsclient";
	import { mapGetters } from "vuex";

	export default {
		name:     "EditUserApp",
		data() {
			return {
				operatorList: [],
				err:          {
					value: false,
					mess: '',
					ok: false
				},
				form:         {
					login:    "",
					password: "",
					confirm:  "",
					comment:  "",
					operator: "",
					role:     1
				}
			};
		},
		beforeMount() {
			this.form.login    = this.getThisUserApp.login;
			this.form.password = this.getThisUserApp.password;
			this.form.comment  = this.getThisUserApp.comment;
			this.form.operator = this.getThisUserApp.operator;
			this.form.role     = this.getThisUserApp.role;
			performRequest(
				{
					section: "tvcontent.operator",
					name:    "getOperatorList"
				},
				{},
				a => {
					if (a.code === 200) {
						this.operatorList = a.data;
						console.log(a.data);
					} else {
						console.log("ошибка загрузки списка операторов");
					}
				});
		},
		computed: {
			...mapGetters(["getThisUserApp"])
		},
		methods:  {
			back() {
				this.$router.push('/update_users')
			},
			send() {
				if (!this.form.password) {
					this.err.value = true;
					this.err.mess = 'Поле пароля не может быть пустым'
				} else if (this.form.password !== this.form.confirm) {
					this.err.value = true;
					this.err.mess = 'Пароли не совпадают'
				} else {
					console.log(this.form);
					performRequest({
							section: "authorize",
							name:    "updateUser"
						},
						{
							...this.form
						},
						a => {
							if (a.code === 200) {
								this.err.value = true;
								this.err.ok = true;
								this.err.mess = `Данные сохранены!`;
								setTimeout(() => {
									this.$router.push('/update_users')
								}, 1500)
								
							} else {
								this.err.value = true;
								this.err.mess = `Данные не были сохранены: ${a.code}`
							}
						}
					);
				}

			}
		}
	};
</script>
<style scoped lang="scss">
	.cont {
		position: absolute;
		margin-top: 5rem;
		width: 30rem;
		background-color: rgba(238, 238, 238, 0.8);
		border-radius: 0.5rem;
		right: 50%;
		transform: translateX(50%);
		box-shadow: inset 0 0 5px #333333;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 1rem 0 2rem 0;
		.err {
			color: red;
			position: absolute;
			top: 45px;
		}
		.green {
			color: green;
		}
		label, input[type="button"] {
			margin-top: 1.5rem;
		}
		input, select {
			width: 300px;
			height: 2rem;
		}
		img {
			width: 30px;
			height: 30px;
			position: absolute;
			right: 10px;
			top: 10px;
			cursor: pointer;
		}
	}
	.slide-enter-active {
		transition: all 0.3s ease;
	}
	.slide-leave-active {
		transition: all 0.3s ease;
	}
	.slide-enter, .slide-leave-to {
		transform: translateX(10px);
		opacity: 0;
	}
	.slide-fade-enter-active {
		transition: all 0.3s ease;
	}
	.slide-fade-leave-active {
		transition: all 0.3s ease;
	}
	.slide-fade-enter, .slide-fade-leave-to {
		transform: translateX(10px);
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/EditUserApp.vue